import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Aarush, Day2, Debattle, Mathocon, Music, ScienceWalk, Synergy, Synergy1, ValedictionDay2 } from 'views/GoonjImages/components';

const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    
      <Box id='Day2'>
        
        <br></br>
        <br></br>
        <Typography variant='h6' align='center' fontWeight={700} >
        DAY 2
        </Typography>

        <Box marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>

          <Day2/>
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>DEBATTLE</Typography>
              <Typography  align='right'>- Colliding thoughts, Symphonic blends</Typography>

            </Box>
            <AccordionDetails>
            Debate empowers young minds and provides them a platform to express their thoughts in a structured setting. Informed arguments help us to identify our differences and discover common ground to work towards solutions, while fostering tolerance and respect for differences.
            <br></br>
            Humour is humanity’s greatest blessing, however, use of the same at a wrong time or way, can be detrimental. The statement of debate was, ‘Humour is the zest of life, albeit at the expense of others.’ The debate provided a mirror to the young minds to be more responsible with their thoughts, speech and action.
            </AccordionDetails>

            <Debattle/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
            {/* <a href="#Day2" align='right'>Back to DAY 2</a> */}
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>AARUSH (Mad ads)</Typography>
              <Typography  align='right'> - A celebration of creativity, humor and effective communication</Typography>

            </Box>
            <AccordionDetails>
            The key to sell a product is to capture the audience’s attention and leave a lasting impression. What better way than comical advertisements! Mad ads - An engaging and entertaining event that challenges participants to showcase their creativity and marketing prowess. The Hindi department had on display an array of ads on various themes.
            </AccordionDetails>

            <Aarush/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>RADICAL – MATHOCON (Mathematical Modelling)</Typography>
              <Typography align='right'> - Resolving real-life problems and unlocking the mysteries of universe</Typography>

            </Box>
            <AccordionDetails>
            “Mathematics is the language with which God has written the Universe,” said Galileo Galilei.
Mathematical modelling is the process of creating a mathematical representation of the real -world system, phenomenon or process. Mathocon proved to be a powerful tool for understanding complex systems and making informed decisions through modelling.

            </AccordionDetails>

            <Mathocon/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>DELTA – SCIENCE WALK</Typography>
              <Typography align='right'> - Blending the beauty of fashion with the wonders of science</Typography>

            </Box>
            <AccordionDetails>
            An extraordinary event that combines the realms of science and fashion, amalgamating scientific knowledge and artistic creativity in a unique and captivating manner. The competition aimed at bridging the gap between science and fashion and fostering collaboration and pushing the boundaries of creativity.
            </AccordionDetails>

            <ScienceWalk/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>SYNERGY – TREASURE HUNT </Typography>
              <Typography align='right'>- Key to treasure – Communication, Collaboration and Creative thinking</Typography>

            </Box>
            <AccordionDetails>
            An exciting and adventurous event to test problem-solving skills, teamwork and the ability to decipher clues to find the hidden treasure. The competition sought to challenge and build a shared sense of excitement that`s hard to beat, map signals that shaped social learning through multiple paths and reinforced the source of information.
            </AccordionDetails>

            <Synergy/>
            <Synergy1/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>MUSIC - THRONE OF APOLLO (Music band) </Typography>
              <Typography align='right'>- One battle, One seat, One to grace the Throne of Apollo!</Typography>

            </Box>
            <AccordionDetails>
            A heartwarming spectacle of children performing in a music band was fresh and the music touched every string of the soul. It was an excellent opportunity to explore creativity and develop musical skills.
            </AccordionDetails>

            <Music/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>VALEDICTION CEREMONY</Typography>

            </Box>
            <AccordionDetails>

            </AccordionDetails>

            <ValedictionDay2/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>


        </Box>
      </Box>
  
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Goonj = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Goonj;